import { render, staticRenderFns } from "./CoverGradient.vue?vue&type=template&id=1efc827a"
import script from "./CoverGradient.vue?vue&type=script&lang=js"
export * from "./CoverGradient.vue?vue&type=script&lang=js"
import style0 from "./CoverGradient.vue?vue&type=style&index=0&id=1efc827a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports